import { useState, useCallback } from "react";
import { NodeViewWrapper, type NodeViewProps } from "@tiptap/react";
import { BlockEditModal } from "../BlockEditModal";

export function CvSectionNodeView({ node, updateAttributes, selected, deleteNode }: NodeViewProps) {
  const title = (node.attrs.title as string) || "";

  const [isOpen, setIsOpen] = useState(false);
  const [draftTitle, setDraftTitle] = useState(title);

  const handleOpen = useCallback(() => {
    setDraftTitle(title);
    setIsOpen(true);
  }, [title]);

  const handleSave = useCallback(() => {
    updateAttributes({ title: draftTitle });
    setIsOpen(false);
  }, [draftTitle, updateAttributes]);

  return (
    <NodeViewWrapper data-type="cv-section-block" data-block-id={node.attrs.blockId} className={selected ? "ProseMirror-selectednode" : ""}>
      <div onClick={handleOpen} style={{
        padding: "12px 0 4px",
        margin: "8px 0 0",
        borderBottom: "2px solid var(--lilia-border, #e5e5e5)",
        cursor: "pointer",
      }} title="Click to edit section title">
        <div style={{
          fontSize: 18, fontWeight: 700,
          textTransform: "uppercase", letterSpacing: "0.05em",
          color: title ? "var(--lilia-text, #111)" : "var(--lilia-text-muted, #999)",
        }}>
          {title || "Section title…"}
        </div>
      </div>

      <BlockEditModal
        sourceNode={node}
        title="Edit CV Section"
        open={isOpen}
        onClose={() => setIsOpen(false)}
        onSave={handleSave}
        onDelete={() => { setIsOpen(false); deleteNode(); }}
        width={420}
      >
        <div>
          <label style={{ display: "block", fontSize: 12, fontWeight: 600, marginBottom: 4 }}>Title</label>
          <input
            value={draftTitle}
            onChange={(e) => setDraftTitle(e.target.value)}
            placeholder="e.g. Experience, Education, Skills"
            autoFocus
            style={{
              width: "100%", padding: "8px 10px", fontSize: 13,
              border: "1px solid var(--lilia-border, #ddd)", borderRadius: 4,
            }}
          />
        </div>
      </BlockEditModal>
    </NodeViewWrapper>
  );
}
